<div class="reports main-div-with-gray-bkg">
    <!-- class="height-separater" -->
    <div class="p-3 pb-0 row">
      <div class="col">
        <h6 class="page-header text-capitalize" *ngIf="pagename && ReportName">{{ pagename + ' > ' + ReportName }}</h6>
      </div>
    </div>
    <div class="p-3 pt-0 row">
      <div style="display: none;" class="col" *ngIf="appliedfilter && appliedfilter.length > 0">
        <strong>Applied Filters:</strong>
        <span>
          <ng-container *ngFor="let filter of appliedfilter; let i = index">
            <span *ngFor="let key of objectKeys(filter)">
              <span class="badge bg-secondary me-1">{{ key }}</span>: {{ checkjson(filter[key]) }}<span *ngIf="i < appliedfilter.length - 1">, </span>
            </span>
          </ng-container>
        </span>
      </div>
    </div>
    <div class="p-3 pt-0 row">
      <div class="col-xs-12 col-sm-12 col-lg-12 col-xl-12 col-xs-12 p-0">
        <div class="card-table-gap p-0">
          <div class="col-xs-12 col-sm-12 col-lg-12 col-xl-12 col-xs-12 card-structure">
            <div class="report" id="reportContainer"></div>
          </div>
        </div>
      </div>
    </div>
  </div>